var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 343,
    viewBox: "0 0 643 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_492)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_492",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 643,
    height: 343
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M642.359 0H0V342.2H642.359V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_492)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8682 325.461H625.619V16.7206H16.8682V325.461ZM633.924 342.2H8.43412C3.78336 342.2 0 338.417 0 333.766V8.43412C0 3.78336 3.78336 0 8.43412 0H633.924C638.575 0 642.358 3.78336 642.358 8.43412V333.747C642.358 338.417 638.575 342.2 633.924 342.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.398 278.196H514.961C519.907 248.963 549.14 219.73 578.374 214.784V127.379C549.14 122.433 519.907 93.1994 514.961 63.9661H127.545C122.599 93.1994 93.3659 122.433 64.1326 127.379V214.784C93.2183 219.748 122.599 248.981 127.398 278.196ZM522.528 294.935H119.683C115.033 294.935 111.249 291.152 111.249 286.501C111.249 261.494 80.5579 230.803 55.5508 230.803C50.9001 230.803 47.1167 227.02 47.1167 222.369V119.701C47.1167 115.051 50.9001 111.267 55.5508 111.267C80.5579 111.267 111.249 80.5759 111.249 55.5689C111.249 50.9181 115.033 47.1348 119.683 47.1348H522.509C527.16 47.1348 530.943 50.9181 530.943 55.5689C530.943 80.5759 561.635 111.267 586.642 111.267C591.293 111.267 595.076 115.051 595.076 119.701V222.369C595.076 227.02 591.293 230.803 586.642 230.803C561.635 230.803 530.943 261.494 530.943 286.501C530.962 291.3 527.178 294.935 522.528 294.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.253 223.089C301.044 223.089 284.453 209.561 284.453 192.84C284.453 188.189 288.236 184.406 292.887 184.406C297.538 184.406 301.321 188.189 301.321 192.84C301.321 200.112 310.475 206.368 321.382 206.368C332.289 206.368 341.443 200.259 341.443 192.84C341.443 184.406 336.645 182.228 319.924 179.165C305.824 176.544 284.73 172.761 284.73 149.064C284.73 129.427 303.204 119.111 321.53 119.111C339.856 119.111 358.33 129.427 358.33 149.064C358.33 153.715 354.547 157.498 349.896 157.498C345.245 157.498 341.462 153.715 341.462 149.064C341.462 138.6 328.377 135.831 321.401 135.831C314.425 135.831 301.34 138.6 301.34 149.064C301.34 157.498 306.138 159.676 322.859 162.739C336.959 165.36 358.201 169.143 358.201 192.84C357.905 209.413 341.462 223.089 321.253 223.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.253 135.979C316.602 135.979 312.819 132.196 312.819 127.545V110.234C312.819 105.583 316.602 101.8 321.253 101.8C325.904 101.8 329.687 105.583 329.687 110.234V127.545C329.54 132.196 325.756 135.979 321.253 135.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.253 240.252C316.602 240.252 312.819 236.469 312.819 231.818V214.507C312.819 209.856 316.602 206.073 321.253 206.073C325.904 206.073 329.687 209.856 329.687 214.507V231.67C329.54 236.469 325.756 240.252 321.253 240.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.117 152.553C117.801 152.553 109.496 160.839 109.496 171.174C109.496 181.509 117.782 189.796 128.117 189.796C138.452 189.796 146.739 181.509 146.739 171.174C146.739 160.839 138.452 152.553 128.117 152.553ZM128.117 206.516C108.628 206.516 92.7754 190.663 92.7754 171.174C92.7754 151.685 108.628 135.832 128.117 135.832C147.606 135.832 163.459 151.685 163.459 171.174C163.459 190.663 147.606 206.516 128.117 206.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.241 152.553C503.924 152.553 495.62 160.839 495.62 171.174C495.62 181.509 503.906 189.796 514.241 189.796C524.576 189.796 532.863 181.509 532.863 171.174C532.863 160.839 524.41 152.553 514.241 152.553ZM514.241 206.516C494.752 206.516 478.899 190.663 478.899 171.174C478.899 151.685 494.752 135.832 514.241 135.832C533.73 135.832 549.583 151.685 549.583 171.174C549.583 190.663 533.711 206.516 514.241 206.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.253 95.2668C279.378 95.2668 245.346 129.299 245.346 171.174C245.346 213.049 279.378 247.081 321.253 247.081C363.128 247.081 397.16 213.049 397.16 171.174C397.16 129.299 362.981 95.2668 321.253 95.2668ZM321.253 263.801C270.205 263.801 228.607 222.203 228.607 171.155C228.607 120.108 270.205 78.5093 321.253 78.5093C372.301 78.5093 413.899 120.108 413.899 171.155C413.899 222.203 372.301 263.801 321.253 263.801Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 643,
    height: 343,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.88ba57c9398048482120d248fdd282cc.svg";
export { ForwardRef as ReactComponent };